import { ApolloCache } from "@apollo/client"

import { ClarificationRequestTypename } from "../types/ClarificationRequest"

export function evictClarificationRequest(
  resourceType: string,
  id: string,
  cache: ApolloCache<object>
) {
  const cacheId = cache.identify({
    __typename: ClarificationRequestTypename,
    id: `${resourceType}:${id}`
  })
  if (!cacheId) return
  cache.evict({ id: cacheId })
}
